export class Controller {

    /** @ngInject */
    constructor($rootScope, $stateParams, LicenseManagementService, Alert) {
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.LicenseManagementService = LicenseManagementService;
        this.Alert = Alert;
    }

    $onInit() {
    }

    startPayment() {
        let purchaseDTO = {
            tierId: this.resolve.tier.tierId,
            priceId: this.resolve.price.priceId,
            userSeats: this.resolve.seats,
            email: this.resolve.email
        }
        this.LicenseManagementService.licensePurchase(this.$stateParams.companyId, purchaseDTO)
        .then(result => {
            if(result.checkoutError) {
                this.Alert('danger', result.checkoutError);
            } else {
                this.sessionUrl = result.sessionUrl;
            }
        })
    }

    okClicked() {
        this.close({$value: this.sessionUrl});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/start-payment/start-license-payment.controller.js